import { ReloadOutlined } from '@ant-design/icons';
import { Button, Drawer, Space } from 'antd';
import classnames from 'classnames';
import React from 'react';

import { CloseButton } from '@client/components/buttons';
import { useDrawer } from '@client/store/drawer.store';

import styles from './components.module.less';

export const DrawerPanel: React.FC = () => {
  const { openDrawer, configDrawer, setOpenDrawer, onRefreshDrawer } =
    useDrawer();

  return (
    <Drawer
      closable={false}
      title={<div className={styles.drawerLabel}>{configDrawer?.title}</div>}
      size={configDrawer?.size}
      rootClassName={classnames(styles.drawer, configDrawer?.className)}
      placement={configDrawer?.placement ?? 'right'}
      open={openDrawer}
      destroyOnHidden
      footer={configDrawer?.footer ?? null}
      extra={
        <Space>
          {((configDrawer?.extra || []) as React.ReactNode[]).map(
            (item, idx) => (
              <div key={idx}>{item}</div>
            ),
          )}
          <Button
            size="small"
            color="primary"
            variant="outlined"
            key="reload"
            onClick={onRefreshDrawer}
            icon={<ReloadOutlined />}
          />
          <CloseButton
            key="close"
            size="small"
            loading={false}
            disabled={false}
            onClick={() => setOpenDrawer(false)}
          />
        </Space>
      }
    >
      <div>{configDrawer?.children}</div>
    </Drawer>
  );
};
